import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllTeamLeads(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      start_date: payload.startDate || "",
      end_date: payload.endDate || "",
      id: payload.userId || "",
      page: String(payload.pageNo ?? 0),
      limit: String(payload.pageSize ?? 25),
      teamId: payload.team_id ? String(payload.team_id) : "",
      formId: payload.formId || "",
      search: payload.search || "",
      memberId: payload.memberId ? String(payload.memberId) : "",
    });
    if (payload.overdue === "1" || payload.overdue === 1 || payload.overdue === true) {
      qs.set("overdue", "1");
    }
    if (payload.untouchedDays != null && payload.untouchedDays !== "") {
      qs.set("untouchedDays", String(payload.untouchedDays));
    }
    if (payload.stage) qs.set("stage", String(payload.stage));
    if (payload.source) qs.set("source", String(payload.source));
    if (payload.fresh === "1" || payload.fresh === 1 || payload.fresh === true) {
      qs.set("fresh", "1");
    }
    if (payload.assignStartDate) {
      qs.set("assign_start_date", String(payload.assignStartDate));
    }
    if (payload.assignEndDate) {
      qs.set("assign_end_date", String(payload.assignEndDate));
    }
    const response = await makeCall(
      `${urls.TEAMLEADDATA}?${qs.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllDepartmentsForFilter() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

/** Load teams; optionally filter by one or more department ids. */
export async function getTeamsForFilter(departmentId?: string | string[]) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    const deptSet = new Set(
      (Array.isArray(departmentId) ? departmentId : [departmentId])
        .map((id) => String(id || "").trim())
        .filter(Boolean)
    );
    const allTeams = Array.isArray(response?.data) ? response.data : [];
    if (!deptSet.size) return { ...response, data: allTeams };
    const filtered = allTeams.filter((t: any) =>
      deptSet.has(String(t?.departmentId || ""))
    );
    return { ...response, data: filtered };
  } catch (error) {
    throw error;
  }
}

export async function getMembersForFilter(teamIds: string[]) {
  try {
    const ids = (teamIds || []).map((id) => String(id || "").trim()).filter(Boolean);
    if (!ids.length) return { data: [], success: 1 };
    const callParams = await getCallParams("POST", { team_id: ids });
    const response = await makeCall(urls.GETMEMBERSDROP, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
